'use client';

import LoadingLink from '@/components/ui/LoadingLink/LoadingLink';
import NextImageView from '@/components/ui/NextImageView/NextImageView';
import RoundArrowIcon from '@/components/ui/RoundArrowIcon/RoundArrowIcon';
import { getImageLayoutSizes } from '@/utils/nextImage';
import type { Route } from 'next';
import styles from './DesignWorkSection.module.scss';

type DesignWorkSectionProps = {
  thumbnailUrl: string;
  workName: string;
  creatorNameList: string[];
  workId: number;
};

/**
 * 作品情報セクション
 * サムネイルと作品名を横並び、作者名を別行で表示
 */
export function DesignWorkSection({ thumbnailUrl, workName, creatorNameList, workId }: DesignWorkSectionProps) {
  const displayCreatorName = creatorNameList.length === 1 ? creatorNameList[0] : creatorNameList.join(' / ');
  const workDetailPath = `/works/${workId}` as Route;

  return (
    <>
      <div className={styles.workInfoContainer}>
        <LoadingLink href={workDetailPath} className={styles.workLogoThumbnailWrapper} aria-label='作品詳細ページへ'>
          <div className={styles.workLogoThumbnail}>
            <NextImageView
              src={thumbnailUrl}
              alt={workName}
              fill={true}
              objectFit='contain'
              sizes={getImageLayoutSizes({ sp: '80px', pc: '160px' })}
            />
          </div>
        </LoadingLink>
        <div className={styles.workInfoText}>
          <LoadingLink href={workDetailPath} className={styles.workName} aria-label='作品詳細ページへ'>
            <h2>{workName}</h2>
          </LoadingLink>
          <LoadingLink href={workDetailPath} className={styles.workAuthor} aria-label='作品詳細ページへ'>
            <p>{displayCreatorName}</p>
          </LoadingLink>
        </div>
        <LoadingLink href={workDetailPath} className={styles.arrowIcon} aria-label='作品詳細ページへ'>
          <RoundArrowIcon direction='right' color='black' size='xLarge' sizePc='xLarge' borderColor='transparent' />
        </LoadingLink>
      </div>
      <hr className={styles.hr} />
    </>
  );
}

export default DesignWorkSection;
